//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import sortBy from 'lodash/sortBy';
import { translate } from 'react-i18next';

import classnames from 'classnames';
import * as Immutable from 'immutable';

import { SelectWithFooter, SelectTypes } from 'common/components/core/select';
import { memoizedImmutable } from 'common/utils/Memoizer';
import { SkillId } from 'common/models/internal/SkillId';
import { Skill } from 'common/models/internal/Skill';
import type { List } from 'immutable';

type Props = {
    theme: Object,
    className?: string,
    selectType?: string,
    value: List<SkillId>,
    skills: List<Skill>,
    options?: Array<SkillOptionType>
};

class MultiSkillSelect extends React.PureComponent<Props, void> {
    @memoizedImmutable()
    getSkillIdsOptions(skills: List<Skill>): Array<SkillOptionType> {
        const skillOptions = [];
        if (skills) {
            skills.forEach(skill => {
                skillOptions.push(skill);
            });
        }
        return sortBy(skillOptions, option => option.name.toUpperCase());
    }

    @memoizedImmutable()
    getSkillIdsValues(skills: List<Skill>): Array<SkillOptionType> {
        let selectedSkillOptions = [];
        if (skills) {
            skills.forEach(skill => {
                selectedSkillOptions = [...selectedSkillOptions, skill.id];
            });
        }
        return selectedSkillOptions;
    }

    getOptionLabel = (skill: Skill) => {
        return skill.name;
    };

    getOptionValue = (skill: Skill) => {
        return skill.id;
    };

    onChange = skillOptions => {
        const { clientId, onChange } = this.props;
        const skills = [];
        skillOptions.length &&
            skillOptions.forEach(skill => {
                skills.push(
                    SkillId.fromJS({
                        clientId: skill.clientId || clientId,
                        id: skill.id
                    })
                );
            });

        onChange && onChange(Immutable.List(skills));
    };

    render() {
        const { theme, className, skills, selectType, ...others } = this.props;
        let { options, value } = this.props;
        if (skills) {
            options = this.getSkillIdsOptions(skills);
            value = this.getSkillIdsValues(value);
        }

        return (
            <SelectWithFooter
                {...others}
                maxMenuHeight={190}
                theme={theme}
                className={classnames(theme.skillsSelector, className)}
                noMarginBottom
                selectType={selectType}
                isMulti
                openMenuOnFocus
                blurInputOnSelect={false}
                isSearchable
                closeMenuOnSelect={false}
                value={value}
                options={options}
                onChange={this.onChange}
                fallbackLabelKey="name"
                fallbackValueKey="id"
                getOptionLabel={this.getOptionLabel}
                getOptionValue={this.getOptionValue}
            />
        );
    }
}

MultiSkillSelect.defaultProps = {
    selectType: SelectTypes.Outline
};

export default themr('MultiSkillSelect')(translate()(MultiSkillSelect));
